import { CKBox, CKMeter, CKMeterProps } from 'clearkit';

import { MeterCompleteCircle } from './MeterCompleteCircle';
import { MeterErrorCircle } from './MeterErrorCircle';

type MeterBoxProps = Omit<CKMeterProps, 'size'> & {
  isComplete?: boolean;
  isError?: boolean;
};

export const MeterBox = ({
  isComplete,
  isError,
  max,
  value,
  variant = 'x',
  ...rest
}: MeterBoxProps) => {
  return (
    <CKBox className="flex items-center justify-center w-12 h-12">
      {isComplete ? (
        <MeterCompleteCircle />
      ) : isError ? (
        <MeterErrorCircle />
      ) : (
        <CKMeter
          {...rest}
          max={max}
          size={30}
          value={value}
          variant={variant}
        />
      )}
    </CKBox>
  );
};
